import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { type IRow, Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import type { PowerDialer } from 'entities/PowerDialer/model/PowerDialer'
import { usePowerDialerListContext } from 'pages/powerDialer/pages/list/context/powerDialerListContext'
import { usePowerDialerWithActionsRows } from 'pages/powerDialer/pages/list/ui/PowerDialerTable/usePowerDialerWithActionsRows'
import { PowerDialerRoutes } from 'pages/powerDialer'
import { getColumns } from './getColumns'
import styles from './styles.module.scss'

export const PowerDialerTable = observer(() => {
  const { limit, page, loading, total, tableStore, onPaginationModelChange, noSearchResults } =
    usePowerDialerListContext()

  const columns = useMemo(() => getColumns(), [])

  const itemsWithActions = usePowerDialerWithActionsRows()

  const getRowLink = (row: IRow<PowerDialer>) =>
    `/${PowerDialerRoutes.root}/${PowerDialerRoutes.view}/${row.id}`

  if (noSearchResults) {
    return <NoResultsFound />
  }

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'PowerDialerTable'}
        pinnedColumnNames={['name']}
        getRowLink={getRowLink}
        store={tableStore}
        columns={columns}
        rows={itemsWithActions}
        rowsCount={total}
        isLoading={loading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        limit={limit}
        startPaginationSize={10}
      />
    </div>
  )
})
